import * as React from 'react'
import * as PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import Input from '@material-ui/core/Input'
import { withStyles } from '@material-ui/core/styles'
import { DataTypeProvider } from '@devexpress/dx-react-grid'

const styles = {
  numericInput: {
    textAlign: 'right',
    width: '100%'
  }
}

const EditorBase = ({ value, onValueChange, classes }) => {
  return (
    <NumberFormat
      fullWidth
      prefix="R$ "
      thousandSeparator="."
      decimalSeparator=","
      value={value}
      customInput={Input}
      onValueChange={values => onValueChange(values.floatValue || '')}
      classes={{
        input: classes.numericInput
      }}
    />
  )
}

EditorBase.propTypes = {
  value: PropTypes.number,
  onValueChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

EditorBase.defaultProps = {
  value: undefined
}

const Editor = withStyles(styles)(EditorBase)

const Formatter = ({ value }) =>
  value &&
  value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

const availableFilterOperations = [
  'equal',
  'notEqual',
  'greaterThan',
  'greaterThanOrEqual',
  'lessThan',
  'lessThanOrEqual'
]

const CurrencyTypeProvider = props => (
  <DataTypeProvider
    formatterComponent={Formatter}
    editorComponent={Editor}
    availableFilterOperations={availableFilterOperations}
    {...props}
  />
)

export default CurrencyTypeProvider
